import styles from './Badge.module.css';

const Badge = ({ color, bg, children, style }) => (
  <span
    className={styles.badge}
    style={{ '--badge-bg': bg, '--badge-color': color, ...style }}
  >
    {children}
  </span>
);

export default Badge;
